/**
 * Controls if a retailer sees the full width category page experience
 */
export const LOGGED_IN_CATEGORY_FULL_WIDTH_XP_240704 = 'LOGGED_IN_CATEGORY_FULL_WIDTH_XP_240704';
